// extracted by mini-css-extract-plugin
export default {"wrapper":"iW-z","availablePromoMessagesLabel":"jW-z","promoMessageList":"kW-z","promoMessage":"lW-z","appliedPromoMessage":"mW-z","promoMessageAmount":"nW-z"};